import { SellingMode } from '@src/core/buyerApiClient';

export type PackageProductForScheduling = {
  productId: string;
  product?: { sellingMode?: SellingMode };
};

export function pickFirstScheduledProductId(products: PackageProductForScheduling[]): string | undefined {
  return (
    products.find((item) => item.product?.sellingMode && item.product.sellingMode !== SellingMode.WithoutDate)
      ?.productId ?? products[0]?.productId
  );
}
